export const apiBaseURL = "http://127.0.0.1:3000";
export const templatesBaseURL = "http://templates.localhost:3001";
export const cdnBaseURL = "http://cdn.localhost:3001";
export const recaptchaKey = "6LdS2egUAAAAAA6oj5pR5wEKHDydVC18B3cfUref";
export const stripePublishableAPIKey = "pk_test_51GrqtVHdEWy9pxpEAHvWzZ0C0DrORqnskV4YHvaZt5BxaYBqg6lpSvUvDPffmHUHU6OxEoa5LfjTzCCaqaj52gPw00CTRSLRuB";
export const wwwBaseURL = "http://localhost:9990";
